// extracted by mini-css-extract-plugin
export default {"root":"BA1EdkIO","download":"IFV7ysPj","image":"asODtWaq"};